import { DateISO } from '@agro-club/agroclub-shared'
import { USCompany } from '../company/types'
import { Profile } from '../user/types'
import { Address } from '../types'

export enum UsContractTypes {
  purchase = 'purchase',
  sale = 'sale',
}
export enum UsContractStatuses {
  new = 'new',
  signed = 'signed',
}

export enum UsContractPositionTypes {
  short = 'short',
  long = 'long',
}

export enum UsPricingTypes {
  priced = 'priced',
  basis = 'basis',
}

export enum UsDeliveryTypes {
  fob = 'fob',
  delivered = 'delivered',
}

export enum UsTransportModes {
  truck = 'truck',
  rail = 'rail',
}

export type UsContractPosition = {
  id: number
  symbol: string
  pricing_type: UsPricingTypes
  quantity: number
  futures_price: number | null
  basis: number | null
  price: number | null
  freight_cost: number | null
  start_date: DateISO
  end_date: DateISO
  transport_mode: UsTransportModes
}

export type UsContract = {
  id: number
  contract_type: UsContractTypes
  status: UsContractStatuses
  sales_person: { id: number; profile?: Profile }
  market_zone?: { id: number; name: string }
  product: { id: number; title: string; slug: string }
  company: USCompany
  address?: Address
  pricing_type: UsPricingTypes
  calculated_quantity: number
  contract_date: DateISO | string
  delivery_type: UsDeliveryTypes
  positions: UsContractPosition[]
  cancelled_at: string | null
  start_date: string
  end_date: string
  is_credit_limit_met: boolean
  is_position_limit_met: boolean
  approved_credit_limit_overdraft: boolean
  approved_position_limit_overdraft: boolean
}

export type UsContractPositionDetailed = UsContractPosition & {
  contract: Omit<UsContract, 'positions' | 'calculated_quantity'>
}

export type TotalsData = {
  contracts: Array<{
    status: UsContractStatuses
    remaining_quantity: number
  }>
  positions: Array<{
    position_type: string
    remaining_quantity: number
  }>
}

export type PositionDTO = {
  id?: number
  symbol: string
  symbolObjectId: string | null
  pricing_type: UsPricingTypes
  quantity: string
  futures_price?: string
  basis?: string
  price?: string
  freight_cost?: string
  start_date: DateISO | string
  end_date: DateISO | string
  transport_mode: UsTransportModes
}

export type UsContractDTO = {
  contract_type: UsContractTypes
  sales_person: string | null
  company: string | null
  market_zone: string | null
  contract_date: string | null
  product: string | null
  delivery_type: UsDeliveryTypes
  pricing_type: UsPricingTypes
  positions: Array<PositionDTO>
}

export enum UsContractsTabs {
  open = 'open',
  closed = 'closed',
}
